import React from 'react';
import { List } from 'semantic-ui-react'
import queries from '../../../../src/utils/queries';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

import TitDer from '../../../components/funcionales/titder';
import getNumDiasMes from '../../../../src/functions/getnumdiasmes';
import general from '../../../modulos/general';

import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { saveAs } from 'file-saver';

var moment = require('moment');

const DetalleNivel1 = ({elemento, metaTipo, avanceMes, handleClickidLista, handleClickActCerrar}) => {
  let fechaIni = new Date()
  let fechaHoy = moment(new Date()).format('YYYY-MM-DD')
  fechaIni = (fechaHoy.substring(0, 4) + '-01-01')
  fechaIni=moment(fechaIni)
  let porcAvance=100, avanceAgno=100
  let agnoHoy=parseInt(fechaHoy.substring(0, 4))
  let mesHoy=parseInt(fechaHoy.substring(5, 7))
  let diaHoy=parseInt(fechaHoy.substring(8, 10))
  if(((agnoHoy*12)+mesHoy)<((elemento.agno*12)+elemento.mesNum)){
    porcAvance=0
  }else{
    if(elemento.estado==='Abierto' && ((agnoHoy*12)+mesHoy)===((elemento.agno*12)+elemento.mesNum)){
      porcAvance=avanceMes
    }
  }
  if(agnoHoy>elemento.agno){
    avanceAgno=100
  }else{
    if(mesHoy>elemento.mesNum){
      const numDM = getNumDiasMes(elemento.mesNum, elemento.agno)
      fechaHoy = elemento.agno + '-' + (elemento.mesNum<10?'0'+elemento.mesNum:elemento.mesNum) + '-' + numDM
    }else{
      fechaHoy = new Date()
      fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
    }
    fechaHoy=moment(fechaHoy)
    let numDias= fechaHoy.diff(fechaIni, 'days')
    if(mesHoy===12 && diaHoy===31){
      avanceAgno=100
    }else{
      avanceAgno = parseInt((numDias*100)/365, 10)
    }
  }
  let bandera='flag red icon'
  if(elemento.porcCumplimientoMeta>=100){
    bandera='flag green icon'
  }else{
    if(elemento.porcCumplimientoMeta>=90){
      bandera='flag green icon'
    }
  }

  let banderaA=''
  if(elemento.metaAcumAgno>0){
    if(Math.round((elemento.valorRealAcumAgno*100)/(elemento.metaAcumAgno-elemento.valor+((elemento.valor*porcAvance)/100)))>=100){
      banderaA='flag green icon'
    }else{
      if(Math.round((elemento.valorRealAcumAgno*100)/(elemento.metaAcumAgno-elemento.valor+((elemento.valor*porcAvance)/100)))>=90){
        banderaA='flag green icon'
      }else{
        banderaA='flag red icon'
      }
    }
  }

  return (
    <tr className=''>
      {/* <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.tipoMeta}</td> */}
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.agno}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.mesNum}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{porcAvance}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{avanceAgno}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.estado?elemento.estado:''}</td>
      {metaTipo!=='Utilidad' &&
        <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.nombreUsuario}</td>
      }
      {/* {metaTipo==='Comercial' &&
        <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
            background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.grupo?elemento.grupo:''}</td>
      }       */}
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.valor?general.formatNum(elemento.valor.toString()):0}</td>
      {metaTipo!=='Utilidad' &&
        <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.metaAgno?general.formatNum(elemento.metaAgno.toString()):0}</td>
      }
      {metaTipo!=='Utilidad' &&
        <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.metaAcumAgno?general.formatNum(elemento.metaAcumAgno.toString()):0}</td>
      }
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.valorReal?general.formatNum(elemento.valorReal.toString()):0}</td>
      {metaTipo!=='Utilidad' &&
        <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.valor?general.formatNum(Math.round((elemento.valor*porcAvance)/100).toString()):0}</td>
      }
      {metaTipo!=='Utilidad' &&
          <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.porcCumplimientoMeta?general.formatNum(elemento.porcCumplimientoMeta.toString()):0}</td>
      }
      {metaTipo!=='Utilidad' &&
        <td className='center aligned' style={{padding: '0.2em'}}>
              <i className={bandera} style={{padding: '0.2em'}}></i>
        </td>      
      }
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.valorRealAcumAgno?general.formatNum(elemento.valorRealAcumAgno.toString()):0}</td>
      {metaTipo!=='Utilidad' &&
        <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.metaAcumAgno?general.formatNum(Math.round(elemento.metaAcumAgno-elemento.valor+((elemento.valor*porcAvance)/100)).toString()):0}</td>
      }
      {metaTipo!=='Utilidad' &&
          <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
                background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.metaAcumAgno?general.formatNum(Math.round((elemento.valorRealAcumAgno*100)/(elemento.metaAcumAgno-elemento.valor+((elemento.valor*porcAvance)/100))).toString()):0}</td>
      }
      {metaTipo!=='Utilidad' &&
        <td className='center aligned' style={{padding: '0.2em'}}>
              <i className={banderaA} style={{padding: '0.2em'}}></i>
        </td>      
      }
      {metaTipo==='Comercial' &&
        <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.rangoAplicado?elemento.rangoAplicado:0}</td>
      }
      {metaTipo==='Comercial' &&
        <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.comisionVentas?general.formatNum(elemento.comisionVentas.toString()):0}</td>
      }
      {metaTipo==='Comercial' &&
        <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.valorRecaudo?general.formatNum(elemento.valorRecaudo.toString()):0}</td>
      }
      {metaTipo==='Comercial' &&
        <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12, color: 'black', 
              background: '#FFFFFF'}} onClick={(ev)=>handleClickidLista(ev, elemento)}>{elemento.valorComision?general.formatNum(elemento.valorComision.toString()):0}</td>
      }
      {elemento.estado==='Abierto' && porcAvance>0 &&
        <td className='center aligned' style={{padding: '0.8em'}}>
          <div className="ui mini vertical red animated button" tabIndex="0" style={{paddingTop: '0.2em', paddingBottom: '0.5em', paddingLeft: '1.0em', paddingRight: '0.1em'}}>
            <div className="hidden content" onClick={(ev)=>handleClickActCerrar(ev, elemento, "Calcular", porcAvance, metaTipo, avanceAgno)}>Calcular</div>
            <div className="visible content">
              <i className="dollar sign up icon" style={{padding: '0.3em'}} onClick={(ev)=>handleClickActCerrar(ev, elemento, "Calcular", porcAvance, metaTipo, avanceAgno)}></i>
            </div>
          </div>
        </td>
      }
      {elemento.estado!=='Abierto' && porcAvance>0 &&
        <td ></td>
      }
      {localStorage.getItem('userLogin')==="slcm@slcm.com" && elemento.estado==='Abierto' && porcAvance>=100 && 
      // {localStorage.getItem('userLogin')==="slcm@slcm.com" && 
      <td className='center aligned' style={{padding: '0.3em'}}>
          <div className="ui mini vertical red animated button" tabIndex="0" style={{paddingTop: '0.2em', paddingBottom: '0.5em', paddingLeft: '1.2em', paddingRight: '0.1em'}}>
            <div className="hidden content" onClick={(ev)=>handleClickActCerrar(ev, elemento, "Cerrar", porcAvance, metaTipo, avanceAgno)}>Cerrar</div>
            <div className="visible content">
              <i className="lock up icon" style={{padding: '0.3em'}} onClick={(ev)=>handleClickActCerrar(ev, elemento, "Cerrar", porcAvance, metaTipo, avanceAgno)}></i>
            </div>
          </div>
        </td>
      }
      {elemento.estado!=='Abierto' &&
        <td ></td>
      }
      {localStorage.getItem('userLogin')==="slcm@slcm.com" && elemento.estado==='Cerrado' && elemento.nombreUsuario!=='slcm' && metaTipo==='Comercial' &&
        <td className='center aligned' style={{padding: '0.3em'}}>
          <div className="ui mini vertical red animated button" tabIndex="0" style={{paddingTop: '0.2em', paddingBottom: '0.5em', paddingLeft: '1.2em', paddingRight: '0.1em'}}>
            <div className="hidden content" onClick={(ev)=>handleClickActCerrar(ev, elemento, "Liquidar", porcAvance, avanceAgno)}>Comisiones</div>
            <div className="visible content">
              <i className="percent icon" style={{padding: '0.3em'}} onClick={(ev)=>handleClickActCerrar(ev, elemento, "Liquidar", porcAvance, metaTipo, avanceAgno)}></i>
            </div>
          </div>
        </td>
      }
      {elemento.estado!=='Cerrado' &&
        <td ></td>
      }
      {localStorage.getItem('userLogin')==="slcm@slcm.com" && elemento.estado==='Liquidado' && elemento.nombreUsuario!=='slcm' && metaTipo==='Comercial' && 
        <td className='center aligned' style={{padding: '0.3em'}}>
          <div className="ui mini vertical red animated button" tabIndex="0" style={{paddingTop: '0.2em', paddingBottom: '0.5em', paddingLeft: '1.2em', paddingRight: '0.1em'}}>
            <div className="hidden content" onClick={(ev)=>handleClickActCerrar(ev, elemento, "pdf", porcAvance, avanceAgno)}>PDF</div>
            <div className="visible content">
              <i className="file pdf icon" style={{padding: '0.3em'}} onClick={(ev)=>handleClickActCerrar(ev, elemento, "pdf", porcAvance, metaTipo, avanceAgno)}></i>
            </div>
          </div>
        </td>
      }
      {elemento.estado!=='Liquidado' &&
        <td ></td>
      }
    </tr>  
  )
};

const Lista = ({list, metaTipo, avanceMes, handleClickidLista, handleClickActCerrar}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} handleClickActCerrar={handleClickActCerrar}
        handleClickidLista={handleClickidLista} metaTipo={metaTipo} avanceMes={avanceMes} 
        key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class GerMeta2 extends React.Component {
  state={permiteUpdate: true, confirmaAct: false, open: false}

handleClickActCerrar = async (ev, elemento, accion, avanceMes, metaTipo, avanceAgno)=>{
  document.body.style.cursor = 'wait'
  let argsUpd = {}
  let allProducto = this.props.allProducto.allProducto
  if(accion==="Calcular" || accion==="Cerrar"){
    if(metaTipo==='Comercial'){
      let argsQuery =`{"$unwind": "$itemsCoti"},
      {$project: {_id: 1, fechaRta: 1, tipoCoti: 1, estadoCoti: 1, descrEmpresa: 1, 
        nombreUsuario: 1, trm: 1, monedaCoti: 1, cantidadAprob: '$itemsCoti.cantidadAprob', valorUniAprob: '$itemsCoti.valorUniAprob', 
        porcDcto: '$itemsCoti.porcDcto', porcIncremento: '$itemsCoti.porcIncremento'}},   
      {$match: {cantidadAprob: {$gt: 0}}},
      {$project: {_id: 1, fechaRta: 1, mes: { $month: '$fechaRta'}, agno: { $year: '$fechaRta'}, tipoCoti: 1, estadoCoti: 1, 
        nombreUsuario: 1, trm: 1, monedaCoti: 1, descrEmpresa: 1, 
        valorItemAprob: {
          $let: {
              vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
              in: { $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}
          }
        }
      }},
      {$group: {_id: {_id: '$_id', fechaRta: '$fechaRta', mes: '$mes', agno: '$agno', tipoCoti: '$tipoCoti', 
        estadoCoti: '$estadoCoti', nombreUsuario: '$nombreUsuario', descrEmpresa: '$descrEmpresa', 
        trm: '$trm', monedaCoti: '$monedaCoti'},
        valorTotalAprob: {$sum: {$toDouble: '$valorItemAprob'}}
      }},
      {$project: {_id: '$_id._id', fechaRta: '$_id.fechaRta', mesComision: '$_id.mes', agnoComision: '$_id.agno', tipoCoti: '$_id.tipoCoti', 
        estadoCoti: '$_id.estadoCoti', nombreUsuario: '$_id.nombreUsuario', descrEmpresa: '$_id.descrEmpresa', 
        trm: '$_id.trm', monedaCoti: '$_id.monedaCoti',
        valorUniAprob: {$toDouble: '$valorTotalAprob'}}},
      {$match: {agnoComision: ${elemento.agno}
      }}`

      let argsQuery2 =`{"$unwind": "$itemsCoti"},
      {$project: {_id: 1, fechaRta: 1, numCoti: 1, 
        nombreUsuario: 1, trm: 1, monedaCoti: 1, cantidadAprob: '$itemsCoti.cantidadAprob', valorUniAprob: '$itemsCoti.valorUniAprob', 
        porcDcto: '$itemsCoti.porcDcto', porcIncremento: '$itemsCoti.porcIncremento', 
        numProductoCoti: '$itemsCoti.numProductoCoti', descrProducto: {"$toString": "$itemsCoti.numProductoCoti"}}},   
      {$match: {cantidadAprob: {$gt: 0}}},
      {$project: {_id: 1, fechaRta: 1, mes: { $month: '$fechaRta'}, agno: { $year: '$fechaRta'}, 
        nombreUsuario: 1, trm: 1, monedaCoti: 1, numProductoCoti: 1, numCoti: 1, descrProducto: 1, 
        valorItemAprob: {
          $let: {
              vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
              in: { $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}
          }
        }
      }},
      {$project: {_id: {$concat: ['$numCoti', '$descrProducto']}, fechaRta: 1, mes: 1, agno: 1, nombreUsuario: 1, trm: 1, monedaCoti: 1, numProductoCoti: 1, 
        valorUniAprob: {$toDouble: '$valorItemAprob'}}},
      {$match: {agno: ${elemento.agno}, mes: ${elemento.mesNum}
      }}`

      let rango1Desde = 0, rango1Hasta = 0, rango2Hasta = 0, rango3Hasta = 0, rangoAplicado = 0, comision = 0
      if(this.props.getParametro.getParametro){
        rango1Desde = this.props.getParametro.getParametro.rango1Desde?this.props.getParametro.getParametro.rango1Desde:0
        rango1Hasta = this.props.getParametro.getParametro.rango1Hasta?this.props.getParametro.getParametro.rango1Hasta:0
        rango2Hasta = this.props.getParametro.getParametro.rango2Hasta?this.props.getParametro.getParametro.rango2Hasta:0
        rango3Hasta = this.props.getParametro.getParametro.rango3Hasta?this.props.getParametro.getParametro.rango3Hasta:0
      }

      let argsBusc =''
      if(elemento.nombreUsuario==='slcm'){
        argsBusc =`tipoCoti: 'Cliente', estadoCoti: 'Aceptada'`
      }else{
        argsBusc =`tipoCoti: 'Cliente', estadoCoti: 'Aceptada', nombreUsuario: '${elemento.nombreUsuario}'`
      }
      let argsBuscarCoti = {tipoqry: `[{$match: {${argsBusc}}}, ${argsQuery}]`}

      let estructura = []
      let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarCoti)
      if(data.allCotizacionRtes && data.allCotizacionRtes.length>0){
        estructura = await data.allCotizacionRtes
      }
      let totalVenta=0, totalVentaAgno=0
      let aplicaComision='N'
      if(estructura.length>0){
        for(let ii=0; ii<estructura.length; ii++){
          let valorVenta=estructura[ii].valorUniAprob
          let trmValor=parseFloat(estructura[ii].trm)
          if(estructura[ii].monedaCoti==='Dolares'){
            valorVenta=parseInt(valorVenta*trmValor)
          }
          
          if(estructura[ii].mesComision<=elemento.mesNum){
            totalVentaAgno+=valorVenta
            if(elemento.mesNum===estructura[ii].mesComision){
              totalVenta+=valorVenta
            }
          }
        }
      }

      let cumplimiento=0, cumplimientoMeta=0, cumplimientoAgno=0
      let valorComision=0
      if(totalVentaAgno > 0){
        cumplimientoAgno=Math.round((totalVentaAgno*100)/elemento.metaAcumAgno)
      }
      if(totalVenta > 0){
        cumplimientoMeta=Math.round((totalVenta*100)/((elemento.valor*avanceMes)/100))
      }
      if(rango1Desde > 0 && rango1Hasta > 0 && rango2Hasta > 0 && totalVenta > 0 && elemento.nombreUsuario!=='slcm' && elemento.grupo!=='Sin grupo'){
        cumplimiento=Math.round((totalVenta*100)/((elemento.valor*avanceMes)/100))

        if(cumplimiento>=rango1Desde || elemento.grupo==='Externos'){
          if(cumplimiento>rango1Hasta){
            if(cumplimiento>rango2Hasta){
              rangoAplicado=3
            }else{
              rangoAplicado=2
            }
          }else{
            rangoAplicado=1
          }
          let estructura3 = []
          let argsBuscarCoti3 = {tipoqry: `[{$match: {${argsBusc}}}, ${argsQuery2}]`}
          let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarCoti3)
          if(data.allCotizacionRtes && data.allCotizacionRtes.length>0){
            estructura3 = await data.allCotizacionRtes
          }
          if(estructura3.length>0){
            let comision=0
            for(let ii=0; ii<estructura3.length; ii++){
              let valorVenta=estructura3[ii].valorUniAprob
              let trmValor=parseFloat(estructura3[ii].trm)
              if(estructura3[ii].monedaCoti==='Dolares'){
                valorVenta=parseInt(valorVenta*trmValor)
              }
              let indexPro = allProducto.findIndex( producto => producto.numProducto===estructura3[ii].numProductoCoti)
              if(indexPro===-1){
              }else{
                if(elemento.grupo==='Externos'){
                  if (!allProducto[indexPro].comisionExt || allProducto[indexPro].comisionExt==null || allProducto[indexPro].comisionExt==''){
                  }else{
                    comision=parseFloat(allProducto[indexPro].comisionExt)
                  }
                }else{
                  switch(rangoAplicado){
                    case 1:
                      if (allProducto[indexPro].comisionRango1==null || allProducto[indexPro].comisionRango1==''){
                      }else{
                        comision=parseFloat(allProducto[indexPro].comisionRango1)
                      }
                      break
                    case 2:
                      if (allProducto[indexPro].comisionRango2==null || allProducto[indexPro].comisionRango2==''){
                      }else{
                        comision=parseFloat(allProducto[indexPro].comisionRango2)
                      }
                      break
                    case 3:
                      if (allProducto[indexPro].comisionRango3==null || allProducto[indexPro].comisionRango3==''){
                      }else{
                        comision=parseFloat(allProducto[indexPro].comisionRango3)
                      }
                      break
                  }
                }
              }
              if(parseFloat(comision)>0){
                valorComision+=parseInt((comision*valorVenta)/100)
              }
            }
          }
        }
      }

      let estado=''
      if(accion==="Calcular"){
        estado='Abierto'
      }else{
        estado='Cerrado'
      }

      argsUpd = {
        _id: elemento._id,
        tipoMeta: elemento.tipoMeta,
        agno: elemento.agno,
        mes: elemento.mes,
        mesNum: elemento.mesNum,
        cedula: elemento.cedula,
        nombreUsuario: elemento.nombreUsuario,
        valor: elemento.valor,
        valorReal: parseInt(totalVenta),
        estado: estado,
        rangoAplicado: rangoAplicado,
        rango1Desde: rango1Desde,
        rango1Hasta: rango1Hasta,
        rango2Hasta: rango2Hasta,
        rango3Hasta: rango3Hasta,
        porcCumplimiento: cumplimiento,
        porcCumplimientoMeta: cumplimientoMeta,
        valorRealAcumAgno: parseInt(totalVentaAgno),
        porcCumplimientoMetaAgno: cumplimientoAgno,
        comisionVentas: valorComision
      }
console.log(argsUpd)
      let response = await this.props.editMeta({
        variables: argsUpd
      });
      const {errors, success} = response.data.editMeta;
      if (!success){
      }else{
        if(accion==="Cerrar"){
          let argsQuery1 =`{$match: {estadoCoti: 'Aceptada'}}, 
          {$project: {_id: 1, numCoti: 1, fechaRta: 1}},   
          {$project: {_id: 1, numCoti: 1, fechaRta: 1, mes: { $month: '$fechaRta'}, agno: { $year: '$fechaRta'}}},
          {$match: {agno: ${elemento.agno}, mes: ${elemento.mesNum}}}`

          let argsBuscarCoti1 = {tipoqry: `[{$match: {${argsBusc}}}, ${argsQuery1}]`}
          console.log(argsBuscarCoti1)
          let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarCoti1)
          let estructura1 = await data.allCotizacionRtes
console.log(rangoAplicado, elemento.grupo)
          if(rangoAplicado>0 || elemento.grupo==='Externos'){
            aplicaComision='S' 
          }
console.log(estructura1)
          for(let ii=0; ii<estructura1.length; ii++){
            const argsUpd = {
              numCoti: estructura1[ii].numCoti,
              aplicaComision: aplicaComision,
              rangoAplicado: rangoAplicado,
              tipoAct: 'Comisiones'
            }
console.log(argsUpd)
            response = await this.props.editCotizacion({
              variables: argsUpd
            });
            const {errors, success} = response.data.editCotizacion;
          }
        }
      }
    }else{
      if(metaTipo==='Facturación'){
        let argsQuery =`{$match: {tipoCoti: 'Cliente', estadoCoti: 'Aceptada', estadoOC: {$in: ['Prefactura', 'Aprobada', 'Factura', 'Pagada']}, 'numOrdenCompra': {$gt: 0}}},
        {$project: {trm: 1, monedaCoti: 1, numOrdenCompra: 1, 
          itemsFactura: {
            $let: {
              vars: {regItem: { $cond: { if: { $isArray: "$itemsFactura" },
                                          then: { $size: "$itemsFactura" },
                                          else: 0} }
              },
              in: { $cond: { if: { $gt: [ "$$regItem", 0 ] },
                                then: "$itemsFactura",
                                else: [{numFactura: '', fechaFact: '', valorFact: 0, valorFactSinIva: 0, trmFactura: 1, numAvance: 0}] 
            }}
          }}
        }},
        {"$unwind": "$itemsFactura"},
        {$project: {trm: 1, monedaCoti: 1, numOrdenCompra: {"$toString": "$numOrdenCompra"}, fechaFact: '$itemsFactura.fechaFact', valorFact: '$itemsFactura.valorFact', 
        valorFactSinIva: '$itemsFactura.valorFactSinIva', trmFactura: '$itemsFactura.trmFactura', numFactura: '$itemsFactura.numFactura', numAvance: {"$toString": "$itemsFactura.numAvance"}}},
        {$match: {numFactura: {$ne: ""}, fechaFact: {$nin: ["", null]}, valorFact: {$gt: 0}}},  
        {$project: {trm: 1, monedaCoti: 1, numOrdenCompra: 1, fechaFact: 1, valorFact: 1, valorFactSinIva: 1, trmFactura: 1, numFactura: 1, numAvance: 1, 
          mesComision: { $toInt: {$substr: [ '$fechaFact', 5, 2 ]}}, agnoComision: { $toInt: {$substr: [ '$fechaFact', 0, 4 ]}}}},
        {$match: {agnoComision: ${elemento.agno}, mesComision: {$lte: ${elemento.mesNum}}}},  
        {$project: {_id: {$concat: ['$numOrdenCompra', '$numAvance']}, trm: 1, monedaCoti: 1, numOrdenCompra: 1, fechaFact: 1, valorFact: 1, valorFactSinIva: 1, trmFactura: 1, numFactura: 1, numAvance: 1, mesComision: 1, agnoComision: 1}},
      {$sort: {agnoComision: 1, mesComision: 1, fechaFact: 1, numFactura: 1}}`

        let argsBuscarCoti = {tipoqry: `[${argsQuery}]`}
        let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarCoti)
        let estructura = await data.allCotizacionRtes
        let valorFactMes=0, valorFactAgno=0, valorFact=0, trmValor=1
        if(estructura.length>0){
          for(let ii=0; ii<estructura.length; ii++){
            if(estructura[ii].valorFactSinIva && estructura[ii].valorFactSinIva>0){
              valorFact=estructura[ii].valorFactSinIva
            }else{
              valorFact=estructura[ii].valorFact
            }
            if(estructura[ii].trmFactura){
              trmValor=estructura[ii].trmFactura?parseFloat(estructura[ii].trmFactura):1
            }else{
              if(estructura[ii].trm){
                trmValor=estructura[ii].trm?parseFloat(estructura[ii].trm):1
              }
            }
            if(estructura[ii].monedaCoti==='Dolares'){
              valorFact=parseInt(valorFact*trmValor)
            }
            // if(estructura[ii].mesComision<=elemento.mesNum){
              valorFactAgno+=valorFact
              if(elemento.mesNum===estructura[ii].mesComision){
                console.log(ii, valorFact, estructura[ii].numFactura, valorFactAgno)
                valorFactMes+=valorFact
              }
            // }
          }
        }
        let cumplimientoAgno=0, cumplimientoMes=0
        if(valorFactMes > 0){
          cumplimientoMes=Math.round((valorFactMes*100)/((elemento.valor*avanceMes)/100))
        }
        if(valorFactAgno > 0){
          cumplimientoAgno=Math.round((valorFactAgno*100)/elemento.metaAcumAgno)
        }

        let estado=''
        if(accion==="Calcular"){
          estado='Abierto'
        }else{
          estado='Cerrado'
        }

        argsUpd = {
          _id: elemento._id,
          tipoMeta: elemento.tipoMeta,
          agno: elemento.agno,
          mes: elemento.mes,
          mesNum: elemento.mesNum,
          cedula: elemento.cedula,
          nombreUsuario: elemento.nombreUsuario,
          valor: elemento.valor,
          valorReal: parseInt(valorFactMes),
          estado: estado,
          rangoAplicado: 0,
          rango1Desde: 0,
          rango1Hasta: 0,
          rango2Hasta: 0,
          rango3Hasta: 0,
          valorRealAcumAgno: parseInt(valorFactAgno),
          porcCumplimientoMetaAgno: cumplimientoAgno,
          porcCumplimientoMeta: cumplimientoMes,
          comisionVentas: 0
        }
        let response = await this.props.editMeta({
          variables: argsUpd
        });
        const {errors, success} = response.data.editMeta;
 
      }
    }
  }else{
    if(accion==="Liquidar"){
      let agnoAnt=0
      let mesAnt=0
      if(elemento.mesNum===1){
        mesAnt=11
        agnoAnt=elemento.agno-1
      }else{
        if(elemento.mesNum===2){
          mesAnt=12
          agnoAnt=elemento.agno-1
        }else{
          mesAnt=elemento.mesNum-2
          agnoAnt=elemento.agno
        }
      }
      let argsQuery3 =`{$match: {tipoCoti: 'Cliente', estadoCoti: 'Aceptada', nombreUsuario: '${elemento.nombreUsuario}'}},
      {$project: {_id: 1, 
        itemsPagos: {
          $let: {
            vars: {regItem: { $cond: { if: { $isArray: "$itemsPagos" },
                                        then: { $size: "$itemsPagos" },
                                        else: 0} }
            },
            in: { $cond: { if: { $gt: [ "$$regItem", 0 ] },
                              then: "$itemsPagos",
                              else: [{fechaRegPago: '', valorPago: 0, trmPago: 0, codiAvance: 0}] 
          }}
        }},
        descrEmpresa: 1, fechaRta: 1, monedaCoti: 1, nombreUsuario: 1, numCoti: 1, numOrdenCompra: 1, ordenCompraCliente: 1, rangoAplicado: 1, numSolic: 1 
      }},  
      {"$unwind": "$itemsPagos"},
      {$project: {_id: 1, descrEmpresa: 1, fechaRta: 1, monedaCoti: 1, nombreUsuario: 1, numCoti: 1, numOrdenCompra: 1, ordenCompraCliente: 1, rangoAplicado: 1, itemsDespacho: 1,
      fechaRegPago: '$itemsPagos.fechaRegPago', valorPago: '$itemsPagos.valorPago', trmPago: '$itemsPagos.trmPago', 
      codiAvance: {"$toString": '$itemsPagos.codiAvance'}, numSolic: 1}},  
      {$project: {_id: {$concat: ['$numCoti', '$codiAvance']}, numSolic: '$_id', 
      descrEmpresa: 1, fechaRta: 1, monedaCoti: 1, nombreUsuario: 1, numCoti: 1, numOrdenCompra: 1, ordenCompraCliente: 1, rangoAplicado: 1, 
      fechaRegPago: 1, valorPago: 1, trmPago: 1, codiAvance: 1, mes: { $toInt: {$substr: [ '$fechaRegPago', 5, 2 ]}}, agno: { $toInt: {$substr: [ '$fechaRegPago', 0, 4 ]}}}},
      {$match: {valorPago: {$gt: 0}, 
        $or: [
          {agno: ${elemento.agno}, mes: ${elemento.mesNum}},
          { agno: ${agnoAnt}, mes: ${mesAnt} }
        ]
      }},
      {$sort: {numOrdenCompra: 1, fechaRegPago: 1}}`

      let argsQuery5 =`{$match: {tipoCoti: 'Cliente', estadoCoti: 'Aceptada', nombreUsuario: '${elemento.nombreUsuario}'}},
      {"$unwind": "$itemsCoti"},
      {$project: {_id: 1, fechaRta: 1, tipoCoti: 1, estadoCoti: 1, descrEmpresa: 1, numCoti: 1, numOrdenCompra: 1, ordenCompraCliente: 1, 
        nombreUsuario: 1, trm: 1, monedaCoti: 1, cantidadAprob: '$itemsCoti.cantidadAprob', valorUniAprob: '$itemsCoti.valorUniAprob', 
        porcDcto: '$itemsCoti.porcDcto', porcIncremento: '$itemsCoti.porcIncremento'}},   
      {$match: {cantidadAprob: {$gt: 0}}},
      {$project: {_id: 1, fechaRta: 1, mes: { $month: '$fechaRta'}, agno: { $year: '$fechaRta'}, tipoCoti: 1, estadoCoti: 1, 
        nombreUsuario: 1, trm: 1, monedaCoti: 1, descrEmpresa: 1, numCoti: 1, numOrdenCompra: 1, ordenCompraCliente: 1, 
        valorItemAprob: {
          $let: {
              vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
              in: { $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}
          }
        }
      }},
      {$group: {_id: {_id: '$_id', fechaRta: '$fechaRta', mes: '$mes', agno: '$agno', tipoCoti: '$tipoCoti', 
        estadoCoti: '$estadoCoti', nombreUsuario: '$nombreUsuario', descrEmpresa: '$descrEmpresa', numCoti: '$numCoti', numOrdenCompra: '$numOrdenCompra', 
        trm: '$trm', monedaCoti: '$monedaCoti', ordenCompraCliente: '$ordenCompraCliente'},
        valorTotalAprob: {$sum: {$toDouble: '$valorItemAprob'}}
      }},
      {$project: {_id: '$_id._id', fechaRta: '$_id.fechaRta', consecAvance: '$_id.mes', consecDespacho: '$_id.agno', tipoCoti: '$_id.tipoCoti', 
        estadoCoti: '$_id.estadoCoti', nombreUsuario: '$_id.nombreUsuario', descrEmpresa: '$_id.descrEmpresa', numCoti: '$_id.numCoti', numOrdenCompra: '$_id.numOrdenCompra', 
        trm: '$_id.trm', monedaCoti: '$_id.monedaCoti', ordenCompraCliente: '$_id.ordenCompraCliente', 
        valorUniAprob: {$toDouble: '$valorTotalAprob'}}},
      {$match: {consecDespacho: ${elemento.agno}, consecAvance: ${elemento.mesNum}}},
      {$sort: {numOrdenCompra: 1, fechaRta: 1}}`

      let argsBuscarCoti2 = {tipoqry: `[${argsQuery3}]`}
      let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarCoti2)
      let estructura2 = await data.allCotizacionRtes
      if(elemento.grupo==='Externos'){}else{
        estructura2 = estructura2.filter(item => (item.aplicaComision==='S'))
      }
      let estructura22 = []
      let tablaRte = [], tablaRte1 = []
      let argsUpd2 = [], argsUpd3 = []
      let posic=65
      if(2>1){
        let argsBuscarCoti22 = {tipoqry: `[${argsQuery5}]`}
        let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarCoti22)
        estructura22 = await data.allCotizacionRtes
      }
      let totalComision=0, totalRecaudo=0, totalVenta=0
      let dirSlcm = 'images/logos/LCMSAS.png'
      let numLineasV=0, numLineasC=0  
      if(estructura22.length>0){
        numLineasV = estructura22.length
        for(let ii=0; ii<estructura22.length; ii++){
          let totalVenta=estructura22[ii].valorUniAprob
          let trmValor=parseFloat(estructura22[ii].trm)
          if(estructura22[ii].monedaCoti==='Dolares'){
            totalVenta=parseInt(totalVenta*trmValor)
          }

          argsUpd3.push(ii+1)
          argsUpd3.push(estructura22[ii].numCoti)
          argsUpd3.push(estructura22[ii].fechaRta.substr(0, 10))
          argsUpd3.push(estructura22[ii].ordenCompraCliente?estructura22[ii].ordenCompraCliente:'')
          argsUpd3.push(estructura22[ii].descrEmpresa)
          argsUpd3.push(new Intl.NumberFormat('de-DE').format(parseInt(totalVenta)))
          tablaRte1.push(argsUpd3) 
          argsUpd3 = []
        }
      }

      let doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
      let widthDoc = (doc.internal.pageSize.width)
      let heightDoc = (doc.internal.pageSize.height)
      let iii=0
      for(let ii=0; ii<estructura2.length; ii++){
        let argsQuery4 =`{$match: {numCoti: '${estructura2[ii].numCoti}'}},
        {$project: {_id: 1, 
          itemsDespacho: {
            $let: {
            vars: {regItem: { $cond: { if: { $isArray: "$itemsDespacho" },
                                          then: { $size: "$itemsDespacho" },
                                          else: 0} }
            },
            in: { $cond: { if: { $gt: [ "$$regItem", 0 ] },
                                then: "$itemsDespacho",
                                else: [{descrProductoDes: '', valorDes: 0, cantidad: 0, porcDctoDes: 0, porcIncrementoDes: 0, estadoComision: '', codAvance: 0, despFact: '', idProducto: 0}] 
            }}
          }}, 
          descrEmpresa: 1, fechaRta: 1, monedaCoti: 1, nombreUsuario: 1, numCoti: 1, numOrdenCompra: 1, ordenCompraCliente: 1, rangoAplicado: 1
        }},  
        {"$unwind": "$itemsDespacho"},
        {$project: {_id: 1, descrEmpresa: 1, fechaRta: 1, monedaCoti: 1, nombreUsuario: 1, numCoti: 1, numOrdenCompra: 1, ordenCompraCliente: 1, rangoAplicado: 1, 
          descrProductoDes: '$itemsDespacho.descrProductoDes', porcDctoDes: '$itemsDespacho.porcDctoDes', 
          valorDes: '$itemsDespacho.valorDes', cantidad: '$itemsDespacho.cantidad', porcIncrementoDes: '$itemsDespacho.porcIncrementoDes', idProducto: '$itemsDespacho.idProducto', 
          estadoComision: '$itemsDespacho.estadoComision', despFact: '$itemsDespacho.despFact', codAvance: '$itemsDespacho.codAvance'}},   
        {$match: {codAvance: ${estructura2[ii].codiAvance}, despFact: 'F', estadoComision: {$ne: 'Liquidada'}}},
          {$project: {_id: {$concat: ['$numCoti', '$descrProductoDes', '$despFact']}, 
          descrEmpresa: 1, fechaRta: 1, monedaCoti: 1, nombreUsuario: 1, numCoti: 1, numOrdenCompra: 1, ordenCompraCliente: 1, rangoAplicado: 1, 
          descrProductoDes: 1, porcDctoDes: 1, idProducto: 1, valorDes: 1, cantidad: 1, porcIncrementoDes: 1, estadoComision: 1, despFact: 1, codAvance: 1}},   
        {$sort: {numOrdenCompra: 1}}`

        // , estadoComision: {$ne: 'Liquidada'}  ==> SE QUITA TEMPORALMENTE DE LA LINEA 689 PARA VOLVER A LIQUIDAR

        let argsBuscarCoti3 = {tipoqry: `[${argsQuery4}]`}
        let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarCoti3)
        let estructura3 = await data.allCotizacionRtes

        if(estructura3.length>0){
          for(let jj=0; jj<estructura3.length; jj++){
            let comision=0, valorBase=0, valorComision=0
            let indexPro = allProducto.findIndex( producto => producto.numProducto===estructura3[jj].idProducto)
            if(indexPro===-1){
            }else{
              if(elemento.grupo==='Externos'){
                if (!allProducto[indexPro].comisionExt || allProducto[indexPro].comisionExt==null || allProducto[indexPro].comisionExt==''){
                }else{
                  comision=parseFloat(allProducto[indexPro].comisionExt)
                }
              }else{
                switch(estructura2[ii].rangoAplicado){
                  case 1:
                    if (allProducto[indexPro].comisionRango1==null || allProducto[indexPro].comisionRango1==''){
                    }else{
                      comision=parseFloat(allProducto[indexPro].comisionRango1)
                    }
                    break
                  case 2:
                    if (allProducto[indexPro].comisionRango2==null || allProducto[indexPro].comisionRango2==''){
                    }else{
                      comision=parseFloat(allProducto[indexPro].comisionRango2)
                    }
                    break
                  case 3:
                    if (allProducto[indexPro].comisionRango3==null || allProducto[indexPro].comisionRango3==''){
                    }else{
                      comision=parseFloat(allProducto[indexPro].comisionRango3)
                    }
                    break
                }
              }
            }

            if(comision>0){
              numLineasC += 1
              valorBase=estructura3[jj].cantidad*estructura3[jj].valorDes
              if(estructura3[jj].porcIncrementoDes>0){
                valorBase=parseInt(valorBase/((100-estructura3[jj].porcIncrementoDes)/100))
              }
              if(estructura3[jj].porcDctoDes>0){
                valorBase=parseInt(valorBase*((100-estructura3[jj].porcDctoDes)/100))
              }
              valorComision=parseInt((comision*valorBase)/100)
              totalComision+=valorComision
              totalRecaudo+=valorBase
              let tipoAc=''
              if(estructura3[jj].idProducto && estructura3[jj].idProducto>0){
                tipoAc = 'EditarItemDespachoComisionID'
              }else{
                tipoAc = 'EditarItemDespachoComision'
              }
              const argsUpd = {
                numCoti: estructura2[ii].numCoti,
                _id: estructura2[ii].numSolic,
                codAvance: parseInt(estructura3[jj].codAvance),
                idProducto: estructura3[jj].idProducto?estructura3[jj].idProducto:0,
                descrProductoDes: estructura3[jj].descrProductoDes,
                porcComision: comision,
                valorComision: valorComision,
                agnoComision: elemento.agno,
                mesComision: elemento.mesNum,
                estadoComision: 'Liquidada',
                despFact: 'F',
                tipoAct: tipoAc
              }
        
              let response = await this.props.editCotizacion({
                variables: argsUpd
              });
              const {errors, success} = response.data.editCotizacion;
              iii+=1
              argsUpd2.push(iii)
              argsUpd2.push(estructura2[ii].fechaRta.substr(0, 10))
              argsUpd2.push(estructura2[ii].fechaRegPago.substr(0, 10))
              argsUpd2.push(estructura2[ii].descrEmpresa)
              argsUpd2.push(estructura2[ii].ordenCompraCliente?estructura2[ii].ordenCompraCliente:'')
              argsUpd2.push(estructura3[jj].descrProductoDes)
              argsUpd2.push(new Intl.NumberFormat('de-DE').format(valorBase))
              argsUpd2.push(estructura2[ii].rangoAplicado)
              argsUpd2.push(comision)
              argsUpd2.push(new Intl.NumberFormat('de-DE').format(valorComision))
              tablaRte.push(argsUpd2) 
              argsUpd2 = []
            }
          }
        }
      }

      argsUpd = {
        _id: elemento._id,
        tipoMeta: elemento.tipoMeta,
        agno: elemento.agno,
        mes: elemento.mes,
        mesNum: elemento.mesNum,
        cedula: elemento.cedula,
        nombreUsuario: elemento.nombreUsuario,
        valor: elemento.valor,
        valorReal: elemento.valorReal,
        estado: 'Liquidado',
        rangoAplicado: elemento.rangoAplicado,
        rango1Desde: elemento.rango1Desde,
        rango1Hasta: elemento.rango1Hasta,
        rango2Hasta: elemento.rango2Hasta,
        rango3Hasta: elemento.rango3Hasta,
        porcCumplimiento: elemento.porcCumplimiento,
        porcCumplimientoMeta: elemento.porcCumplimientoMeta,
        valorRecaudo: parseInt(totalRecaudo),
        valorComision: parseInt(totalComision)
      }

      let response = await this.props.editMeta({
        variables: argsUpd
      });
      const {errors, success} = response.data.editMeta;
      document.body.style.cursor = 'default'

    }else{
      let agnoAnt=0
      let mesAnt=0
      if(elemento.mesNum===1){
        mesAnt=11
        agnoAnt=elemento.agno-1
      }else{
        if(elemento.mesNum===2){
          mesAnt=12
          agnoAnt=elemento.agno-1
        }else{
          mesAnt=elemento.mesNum-2
          agnoAnt=elemento.agno
        }
      }
      let argsQuery3 =`{$match: {tipoCoti: 'Cliente', estadoCoti: 'Aceptada', nombreUsuario: '${elemento.nombreUsuario}'}},
      {$project: {_id: 1, 
        itemsPagos: {
          $let: {
            vars: {regItem: { $cond: { if: { $isArray: "$itemsPagos" },
                                        then: { $size: "$itemsPagos" },
                                        else: 0} }
            },
            in: { $cond: { if: { $gt: [ "$$regItem", 0 ] },
                              then: "$itemsPagos",
                              else: [{fechaRegPago: '', valorPago: 0, trmPago: 0, codiAvance: 0}] 
          }}
        }},
        descrEmpresa: 1, fechaRta: 1, monedaCoti: 1, nombreUsuario: 1, numCoti: 1, numOrdenCompra: 1, rangoAplicado: 1, numSolic: 1, ordenCompraCliente: 1,  
      }},  
      {"$unwind": "$itemsPagos"},
      {$project: {_id: 1, descrEmpresa: 1, fechaRta: 1, monedaCoti: 1, nombreUsuario: 1, numCoti: 1, numOrdenCompra: 1, ordenCompraCliente: 1, rangoAplicado: 1, itemsDespacho: 1,
      fechaRegPago: '$itemsPagos.fechaRegPago', valorPago: '$itemsPagos.valorPago', trmPago: '$itemsPagos.trmPago', 
      codiAvance: {"$toString": '$itemsPagos.codiAvance'}, numSolic: 1}},  
      {$project: {_id: {$concat: ['$numCoti', '$codiAvance']}, numSolic: '$_id', 
      descrEmpresa: 1, fechaRta: 1, monedaCoti: 1, nombreUsuario: 1, numCoti: 1, numOrdenCompra: 1, ordenCompraCliente: 1, rangoAplicado: 1, 
      fechaRegPago: 1, valorPago: 1, trmPago: 1, codiAvance: 1, mes: { $toInt: {$substr: [ '$fechaRegPago', 5, 2 ]}}, agno: { $toInt: {$substr: [ '$fechaRegPago', 0, 4 ]}}}},
      {$match: {valorPago: {$gt: 0}, 
        $or: [
          {agno: ${elemento.agno}, mes: ${elemento.mesNum}},
          { agno: ${agnoAnt}, mes: ${mesAnt} }
        ]
      }},
      {$sort: {numOrdenCompra: 1, fechaRegPago: 1}}`

      let argsQuery5 =`{$match: {tipoCoti: 'Cliente', estadoCoti: 'Aceptada', nombreUsuario: '${elemento.nombreUsuario}'}},
      {"$unwind": "$itemsCoti"},
      {$project: {_id: 1, fechaRta: 1, tipoCoti: 1, estadoCoti: 1, descrEmpresa: 1, numCoti: 1, numOrdenCompra: 1, ordenCompraCliente: 1, 
        aplicaComision: 1, rangoAplicado: 1, nombreUsuario: 1, trm: 1, monedaCoti: 1, cantidadAprob: '$itemsCoti.cantidadAprob', valorUniAprob: '$itemsCoti.valorUniAprob', 
        descrProducto: '$itemsCoti.descrProducto', porcDcto: '$itemsCoti.porcDcto', porcIncremento: '$itemsCoti.porcIncremento', numProductoCoti: '$itemsCoti.numProductoCoti'}},   
      {$match: {cantidadAprob: {$gt: 0}}},
      {$project: {_id: 1, fechaRta: 1, mes: { $month: '$fechaRta'}, agno: { $year: '$fechaRta'}, tipoCoti: 1, estadoCoti: 1, aplicaComision: 1, rangoAplicado: 1, 
        nombreUsuario: 1, trm: 1, monedaCoti: 1, descrEmpresa: 1, numCoti: 1, numOrdenCompra: 1, ordenCompraCliente: 1, descrProducto: 1, numProductoCoti: 1, cantidadAprob: 1, 
        valorItemAprob: {
          $let: {
              vars: {cantidadAprob: {$toInt: '$cantidadAprob'}, valorUniAprob: '$valorUniAprob', porcDcto: {$toDouble: '$porcDcto'}, porcIncremento: {$toInt: '$porcIncremento'}},
              in: { $multiply: [ "$$cantidadAprob", {$multiply: [{$divide: ["$$valorUniAprob", {$divide: [{$add: ["$$porcIncremento", -100]}, -100 ]} ]}, {$divide: [{$add: ["$$porcDcto", -100]}, -100 ]} ]} ]}
          }
        }
      }},
      {$project: {_id: 1, fechaRta: 1, mes: { $month: '$fechaRta'}, agno: { $year: '$fechaRta'}, tipoCoti: 1, estadoCoti: 1, aplicaComision: 1, rangoAplicado: 1, 
        nombreUsuario: 1, trm: 1, monedaCoti: 1, descrEmpresa: 1, numCoti: 1, numOrdenCompra: 1, ordenCompraCliente: 1, descrProducto: 1, numProductoCoti: 1,
        cantidadAprob: 1, valorUniAprob: {$toDouble: '$valorItemAprob'}}},
      {$match: {agno: ${elemento.agno}, mes: ${elemento.mesNum}}},
      {$lookup: {from: 'productos', localField: 'numProductoCoti', foreignField: 'numProducto', as: 'producto'}},
      {$unwind: '$producto'},
      {$project: {_id: {$concat: ['$numCoti', '$descrProducto']}, fechaRta: 1, mes: 1, agno: 1, tipoCoti: 1, estadoCoti: 1, aplicaComision: 1, rangoAplicado: 1, 
        nombreUsuario: 1, trm: 1, monedaCoti: 1, descrEmpresa: 1, numCoti: 1, numOrdenCompra: 1, ordenCompraCliente: 1, descrProducto: 1, 
        cantidadAprob: 1, valorUniAprob: 1, valorUniCoti: '$producto.comisionRango1', numOrdenCompraCli: '$producto.comisionRango2',
        consecAvance: '$producto.comisionRango3', consecDespacho: '$producto.comisionExt'}},
      {$sort: {numOrdenCompra: 1, fechaRta: 1}}`

      let argsBuscarCoti2 = {tipoqry: `[${argsQuery3}]`}
      let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarCoti2)
      let estructura2 = await data.allCotizacionRtes
      if(elemento.grupo==='Externos'){}else{
        estructura2 = estructura2.filter(item => (item.aplicaComision==='S'))
      }      
      let estructura22 = []
      let tablaRte = [], tablaRte1 = []
      let argsUpd2 = [], argsUpd3 = []
      let posic=65
      let totalComisionMes=0

      if(2>1){
        let argsBuscarCoti22 = {tipoqry: `[${argsQuery5}]`}
        let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarCoti22)
        estructura22 = await data.allCotizacionRtes
        console.log(estructura22)
      }
      let totalComision=0, totalRecaudo=0, totalVenta=0
      let dirSlcm = 'images/logos/LCMSAS.png'
      let numLineasV=0, numLineasC=0

      if(estructura22.length>0){
        let iii=0
        numLineasV=estructura22.length
        for(let ii=0; ii<estructura22.length; ii++){
          let totalVenta=parseInt(estructura22[ii].valorUniAprob)
          let trmValor=parseFloat(estructura22[ii].trm)
          let comision=0, valorComision=0
          if(estructura22[ii].monedaCoti==='Dolares'){
            totalVenta=parseInt(totalVenta*trmValor)
          }            
          if(totalVenta>0){
            if(elemento.grupo==='Externos'){
              comision=parseFloat(estructura22[ii].consecDespacho)
            }else{
              if(estructura22[ii].aplicaComision==='S' && estructura22[ii].rangoAplicado && estructura22[ii].rangoAplicado>0){
                switch(estructura22[ii].rangoAplicado){
                  case 1:
                    comision=parseFloat(estructura22[ii].valorUniCoti)
                    break
                  case 2:
                    comision=parseFloat(estructura22[ii].numOrdenCompraCli)
                    break
                  case 3:
                    comision=parseFloat(estructura22[ii].consecAvance)
                    break
                }
              }
            }
            if(parseFloat(comision)>0){
              valorComision=parseInt((comision*totalVenta)/100)
              totalComisionMes+=valorComision
            }  
          }
          
          iii+=1
          argsUpd3.push(iii)
          argsUpd3.push(estructura22[ii].fechaRta.substr(0, 10))
          argsUpd3.push(estructura22[ii].descrEmpresa)
          argsUpd3.push(estructura22[ii].numOrdenCompra)
          argsUpd3.push(estructura22[ii].ordenCompraCliente?estructura22[ii].ordenCompraCliente:'')
          argsUpd3.push(new Intl.NumberFormat('de-DE').format(estructura22[ii].cantidadAprob))
          argsUpd3.push(estructura22[ii].descrProducto)
          argsUpd3.push(new Intl.NumberFormat('de-DE').format(totalVenta))
          argsUpd3.push(estructura22[ii].rangoAplicado)
          argsUpd3.push(comision)
          argsUpd3.push(new Intl.NumberFormat('de-DE').format(valorComision))
          tablaRte1.push(argsUpd3) 
          argsUpd3 = []
        }
      }


      let doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})
      let widthDoc = (doc.internal.pageSize.width)
      let heightDoc = (doc.internal.pageSize.height)
      let iii=0
      for(let ii=0; ii<estructura2.length; ii++){
        let argsQuery4 =`{$match: {numCoti: '${estructura2[ii].numCoti}'}},
        {$project: {_id: 1, 
                    itemsFactura: {
                $let: {
                  vars: {regItem: { $cond: { if: { $isArray: "$itemsFactura" },
                                                then: { $size: "$itemsFactura" },
                                                else: 0} }
                  },
                  in: { $cond: { if: { $gt: [ "$$regItem", 0 ] },
                                      then: "$itemsFactura",
                                      else: [{numFactura: '', numAvance: 0}] 
                  }}
              }},
              itemsDespacho: {
                $let: {
                  vars: {regItem: { $cond: { if: { $isArray: "$itemsDespacho" },
                                                then: { $size: "$itemsDespacho" },
                                                else: 0} }
                  },
                  in: { $cond: { if: { $gt: [ "$$regItem", 0 ] },
                                      then: "$itemsDespacho",
                                      else: [{descrProductoDes: '', valorComision: 0, porcComision: 0, agnoComision: 0, mesComision: 0, cantidad: 0, valorDes: 0, porcIncremento: 0, porDctoDes: 0}] 
                  }}
              }},
                descrEmpresa: 1, fechaRta: 1, monedaCoti: 1, nombreUsuario: 1, numCoti: 1, numOrdenCompra: 1, rangoAplicado: 1}},
        {"$unwind": "$itemsDespacho"},
        {$project: {_id: 1, descrEmpresa: 1, fechaRta: 1, monedaCoti: 1, nombreUsuario: 1, numCoti: 1, numOrdenCompra: 1, rangoAplicado: 1, itemsFactura: 1, 
          descrProductoDes: '$itemsDespacho.descrProductoDes', valorComision: '$itemsDespacho.valorComision', porcComision: '$itemsDespacho.porcComision', 
          agnoComision: '$itemsDespacho.agnoComision', mesComision: '$itemsDespacho.mesComision', cantidad: '$itemsDespacho.cantidad', valorDes: '$itemsDespacho.valorDes', 
          porcIncrementoDes: '$itemsDespacho.porcIncrementoDes', porcDctoDes: '$itemsDespacho.porcDctoDes', 
          estadoComision: '$itemsDespacho.estadoComision', despFact: '$itemsDespacho.despFact', codAvance: '$itemsDespacho.codAvance'}},   
        {$match: {codAvance: ${estructura2[ii].codiAvance}, despFact: 'F', estadoComision: 'Liquidada', agnoComision: ${elemento.agno}, mesComision: ${elemento.mesNum}}},
        {$project: {_id: 1, descrEmpresa: 1, fechaRta: 1, monedaCoti: 1, nombreUsuario: 1, itemsFactura: 1, 
          numCoti: 1, numOrdenCompra: 1, rangoAplicado: 1, descrProductoDes: 1, valorComision: 1, porcComision: 1, agnoComision: 1, mesComision: 1, cantidad: 1, 
          valorDes: 1, porcIncrementoDes: 1, porcDctoDes: 1, estadoComision: 1, despFact: 1, codAvance: 1}},
        {"$unwind": "$itemsFactura"},
        {$project: {_id: 1, descrEmpresa: 1, fechaRta: 1, monedaCoti: 1, nombreUsuario: 1, numCoti: 1, numOrdenCompra: 1, rangoAplicado: 1, 
          descrProductoDes: 1, valorComision: 1, porcComision: 1, agnoComision: 1, mesComision: 1, cantidad: 1, 
          valorDes: 1, porcIncrementoDes: 1, porcDctoDes: 1, estadoComision: 1, despFact: 1, codAvance: 1, 
          numFactura: '$itemsFactura.numFactura', numAvance: '$itemsFactura.numAvance'}},   
        {$match: {numAvance: ${estructura2[ii].codiAvance}}},
        {$project: {_id: {$concat: ['$numCoti', '$descrProductoDes', '$despFact']}, 
          descrEmpresa: 1, fechaRta: 1, monedaCoti: 1, nombreUsuario: 1, numCoti: 1, numOrdenCompra: 1, rangoAplicado: 1, 
          descrProductoDes: 1, valorComision: 1, agnoComision: 1, mesComision: 1, estadoComision: 1, despFact: 1, codAvance: 1,
          porcIncrementoDes: 1, porcDctoDes: 1, cantidad: 1, valorDes: 1, porcComision: 1, numFactura: 1}},   
        {$sort: {numOrdenCompra: 1}}`

        let argsBuscarCoti3 = {tipoqry: `[${argsQuery4}]`}
        let {data} = await this.props.allCotizacionRtes.refetch(argsBuscarCoti3)
        let estructura3 = await data.allCotizacionRtes

        for(let jj=0; jj<estructura3.length; jj++){
          let valorComision=estructura3[jj].valorComision
          let comision=estructura3[jj].porcComision
          if(valorComision>0){
            numLineasC+=1
            let valorBase=estructura3[jj].cantidad*estructura3[jj].valorDes
            if(estructura3[jj].porcIncrementoDes>0){
              valorBase=parseInt(valorBase/((100-estructura3[jj].porcIncrementoDes)/100))
            }
            if(estructura3[jj].porcDctoDes>0){
              valorBase=parseInt(valorBase*((100-estructura3[jj].porcDctoDes)/100))
            }
            valorComision=parseInt((comision*valorBase)/100)
            iii+=1
 
            argsUpd2.push(iii)
            argsUpd2.push(estructura2[ii].fechaRta.substr(0, 10))
            argsUpd2.push(estructura2[ii].fechaRegPago.substr(0, 10))
            argsUpd2.push(estructura2[ii].descrEmpresa)
            argsUpd2.push(estructura2[ii].numOrdenCompra)
            argsUpd2.push(estructura2[ii].ordenCompraCliente?estructura2[ii].ordenCompraCliente:'')
            argsUpd2.push(estructura3[jj].numFactura)
            argsUpd2.push(estructura3[jj].descrProductoDes)
            argsUpd2.push(new Intl.NumberFormat('de-DE').format(valorBase))
            argsUpd2.push(estructura2[ii].rangoAplicado)
            argsUpd2.push(comision)
            argsUpd2.push(new Intl.NumberFormat('de-DE').format(valorComision))
            tablaRte.push(argsUpd2) 
            argsUpd2 = []
          }
        }
      }
      if (elemento.valorComision>0 || elemento.valorReal>0){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha

        let agno=elemento.agno?elemento.agno:''
        let valor=elemento.valor
        let valorReal=parseInt(elemento.valorReal)
        let porcCumplimiento=elemento.porcCumplimiento
        let porcCumplimientoMeta=elemento.porcCumplimientoMeta
        let rangoAplicado=elemento.rangoAplicado
        let totalRecaudo=elemento.valorRecaudo
        let totalComision=elemento.valorComision


        doc.setFillColor('#E9E4F0');
        doc.setDrawColor('black');
        doc.line(12, 35, widthDoc-12, 35)    
        doc.line(12, 40, widthDoc-12, 40)    
        doc.line(12, 45, widthDoc-12, 45)    
        doc.line(12, 50, widthDoc-12, 50)    
        doc.line(12, 55, widthDoc-12, 55)    
        doc.line(12, 60, widthDoc-12, 60)    
        doc.line(42, 30, 42, 60)  
        doc.line(105, 30, 105, 60) 
        doc.line(136, 30, 136, 60) 
        doc.lines([[(widthDoc)-24.4,0],[0,4.6],[0-(widthDoc)+24.4,0]], 12.3,30.3, [1,1], 'F', true)
        doc.lines([[(widthDoc)-24.4,0],[0,4.6],[0-(widthDoc)+24.4,0]], 12.3,60.2, [1,1], 'F', true)

        doc.setFontSize(8);
        doc.text(`INFORMACION GENERAL `, 87, 34, {align: 'left',lineHeightFactor: 1,maxWidth:58})
        doc.text(`NOMBRE`, 14, 39)
        doc.text(elemento.nombreUsuario, 45, 39)
        doc.text(`AÑO`, 14, 44)
        doc.text(agno + '', 45, 44)
        doc.text(`META`, 14, 49)
        doc.text('$ ' + new Intl.NumberFormat('de-DE').format(valor), 45, 49)
        doc.text(`CUMPLIMIENTO`, 14, 54)
        doc.text(porcCumplimiento + ' %', 45, 54)
        doc.text(`TOTAL RECAUDO`, 14, 59)
        doc.text('$ ' + new Intl.NumberFormat('de-DE').format(totalRecaudo), 45, 59)
        doc.text(`CEDULA`, 106.5, 39)
        doc.text(elemento.cedula, 140, 39)
        doc.text(`MES`, 106.5, 44)
        doc.text(elemento.mes, 140, 44)
        doc.text(`TOTAL VENTAS`, 106.5, 49)
        doc.text('$ ' + new Intl.NumberFormat('de-DE').format(valorReal), 140, 49)
        doc.text(`RANGO`, 106.5, 54)
        doc.text(rangoAplicado + '', 140, 54)
        doc.text(`COMISION RECAUDO`, 106.5, 59)
        doc.text('$ ' + new Intl.NumberFormat('de-DE').format(totalComision), 140, 59)
        doc.rect(12, 30, widthDoc-24, 35) 
        doc.text(`DETALLE DE VENTAS `, 89, 64, {align: 'left',lineHeightFactor: 1,maxWidth:58})

        if (valorReal>0){
          argsUpd3.push('TOTAL VENTAS')
          argsUpd3.push('')
          argsUpd3.push('')
          argsUpd3.push('')
          argsUpd3.push('')
          argsUpd3.push('')
          argsUpd3.push('')
          argsUpd3.push(new Intl.NumberFormat('de-DE').format(valorReal))
          argsUpd3.push('')
          argsUpd3.push('')
          argsUpd3.push(new Intl.NumberFormat('de-DE').format(totalComisionMes))
          tablaRte1.push(argsUpd3) 
          argsUpd3 = []

          doc.autoTable({
            startY: 65,
            rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
            showHead: 'everyPage',
            tableLineColor: "black",
            tableLineWidth: 0.1,
            styles: {
              fontSize: 6,
              lineColor: "black",
              lineWidth: 0.1,
            },
            headStyles: {
              fillColor: "#E9E4F0",
              textColor: "black",
              halign: "center",
              valign: "top",
              cellPadding: 1,
              fontStyle: "bold",
              fontSize: 6
            },
            bodyStyles: {
              fillColor: "white",
              textColor: "black",
              halign: "center",
            },
            columnStyles: {
              0: {cellWidth: ((widthDoc-24)*3)/100},
              1: {cellWidth: ((widthDoc-24)*8)/100},
              2: {cellWidth: ((widthDoc-24)*10)/100},
              3: {cellWidth: ((widthDoc-24)*8)/100},
              4: {cellWidth: ((widthDoc-24)*10)/100},
              5: {cellWidth: ((widthDoc-24)*8)/100},
              6: {cellWidth: ((widthDoc-24)*24.2)/100},
              7: {cellWidth: ((widthDoc-24)*9)/100},
              8: {cellWidth: ((widthDoc-24)*4.5)/100},
              9: {cellWidth: ((widthDoc-24)*6)/100},
              10: {cellWidth: ((widthDoc-24)*7.2)/100},
            },

            didParseCell(data) {
              if(data.row.index !== -1 && data.section==='body'){
                data.cell.styles.minCellHeight = 1
                data.cell.styles.fillColor = "white"
                data.cell.styles.fontStyle = "normal"
              }
              if(data.row.index === numLineasV && data.section==='body'){
                if(data.column.index === 0){
                  data.cell.colSpan = 7
                }
              }
            },

            didDrawCell: (data) => {
              //imagenes en autoTable
              //https://github.com/simonbengtsson/jsPDF-AutoTable/issues/93
              if(data.row.index===-1){
              console.log("ojoooo")
              }
            },
            alternateRowStyles: {
              // fillColor: "white",
              textColor: "black"
            },
            head: [["Item", "Fecha venta", "Cliente", "OC LCM", "OC Cliente", "Cantidad", "Producto", "Vlr total", "Rango", "% Comisión", "Comisión ventas"]],
            body: tablaRte1,
            margin: {top: 35, left: 12, right: 12, bottom: 25}
          })
          if (totalComision>0){
            doc.addPage()
          }
        }

        if (totalComision>0){
          argsUpd2.push('TOTAL COMISION')
          argsUpd2.push('')
          argsUpd2.push('')
          argsUpd2.push('')
          argsUpd2.push('')
          argsUpd2.push('')
          argsUpd2.push('')
          argsUpd2.push('')
          argsUpd2.push(new Intl.NumberFormat('de-DE').format(totalRecaudo))
          argsUpd2.push('')
          argsUpd2.push('')
          argsUpd2.push(new Intl.NumberFormat('de-DE').format(totalComision))
          tablaRte.push(argsUpd2) 
          argsUpd2 = []
          if (valorReal>0){
            posic=35
          }else{
            posic=75
          }
          doc.setFillColor('#E9E4F0');
          doc.setDrawColor('black');
          doc.lines([[(widthDoc)-24.4,0],[0,4.6],[0-(widthDoc)+24.4,0]], 12.3,posic-4.5, [1,1], 'F', true)
          doc.rect(12, 30, widthDoc-24, posic) 
          doc.text(`DETALLE DE COMISIONES `, 87, posic-1, {align: 'left',lineHeightFactor: 1,maxWidth:58})
          doc.autoTable({
            startY: posic,
            rowPageBreak: 'avoid',  //cambia de página si la ultima fila queda incompleta
            showHead: 'everyPage',
            tableLineColor: "black",
            tableLineWidth: 0.1,
            styles: {
              fontSize: 6,
              lineColor: "black",
              lineWidth: 0.1,
            },
            headStyles: {
              fillColor: "#E9E4F0",
              textColor: "black",
              halign: "center",
              valign: "top",
              cellPadding: 1,
              fontStyle: "bold",
              fontSize: 6
            },
            bodyStyles: {
              fillColor: "white",
              textColor: "black",
              halign: "center",
            },
            columnStyles: {
              0: {cellWidth: ((widthDoc-24)*3)/100},
              1: {cellWidth: ((widthDoc-24)*8)/100},
              2: {cellWidth: ((widthDoc-24)*8)/100},
              3: {cellWidth: ((widthDoc-24)*13)/100},
              4: {cellWidth: ((widthDoc-24)*8)/100},
              5: {cellWidth: ((widthDoc-24)*6)/100},
              6: {cellWidth: ((widthDoc-24)*7)/100},
              7: {cellWidth: ((widthDoc-24)*19.1)/100},
              8: {cellWidth: ((widthDoc-24)*8)/100},
              9: {cellWidth: ((widthDoc-24)*4.5)/100},
              10: {cellWidth: ((widthDoc-24)*6)/100},
              11: {cellWidth: ((widthDoc-24)*7.2)/100},
            },

            didParseCell(data) {
              if(data.row.index !== -1 && data.section==='body'){
                data.cell.styles.minCellHeight = 1
                data.cell.styles.fillColor = "white"
                data.cell.styles.fontStyle = "normal"
              }
              if(data.row.index === numLineasC && data.section==='body'){
                if(data.column.index === 0){
                  data.cell.colSpan = 8
                }
              }
            },

            didDrawCell: (data) => {
              //imagenes en autoTable
              //https://github.com/simonbengtsson/jsPDF-AutoTable/issues/93
              if(data.row.index===-1){
              console.log("ojoooo")
              }
            },
            alternateRowStyles: {
              // fillColor: "white",
              textColor: "black"
            },
            head: [["Item", "Fecha venta", "Fecha recaudo", "Cliente", "OC LCM", "OC Cliente", "Factura", "Producto", "Recaudo", "Rango", "% Comisión", "Comisión recaudo"]],
            body: tablaRte,
            margin: {top: 35, left: 12, right: 12, bottom: 25}
          })
        }




        const pageCount = doc.internal.getNumberOfPages();
        // For each page, print the page number and the total pages
        for(var i = 1; i <= pageCount; i++) {
              // Go to page i
            doc.setPage(i);

  //ENCABEZADO DE PAGINA
            doc.setFontSize(10);
            doc.setTextColor('black');
            doc.setFontType("bold");
            doc.text("LIQUIDACION DE COMISIONES ", widthDoc/2, 25, 'center')
            doc.setFontSize(8);

            let dirSlcm = 'images/logos/LCMSAS.png'
            let logo = ""
            let imgSource = new Image();
            try{
              imgSource.src = dirSlcm;
              doc.convertStringToImageData(imgSource)
              doc.addImage(imgSource, 'PNG', 12, 12, 55, 17);
            }catch{
              console.log("Logo de LCM no existe")
            }
  //FIN ENCABEZADO DE PAGINA

  //PIE DE PAGINA

            // doc.setFontSize(8);
            // doc.setTextColor(255,0,0);
            // doc.setFontStyle('Watermark');
            // doc.text(empresaWeb, widthDoc/2, heightDoc-15, 'center')
            // doc.text("Colombia - Ecuador - Panamá", widthDoc/2, heightDoc-12, 'center')

            doc.text('Pag ' + String(i) + ' de ' + String(pageCount), 12, heightDoc-12, 'left')
            doc.text(fechaHoraHoy.substr(0, 10) + " " + fechaHoraHoy.substr(11, 5), widthDoc-50, heightDoc-12, 'left')
              // doc.text('Pag ' + String(i) + ' de ' + String(pageCount),210-20,297-30,null,null,"left");
          }
        let nameDoc = `COMISIONES_${elemento.nombreUsuario}_${elemento.agno}_${elemento.mes}.pdf`
        document.body.style.cursor = 'default'
        doc.save(nameDoc)

      }
      
    }
  }

  if(elemento.tipoMeta==='Comercial'){
    this.props.allMetaRtes.refetch()
  }
  if(elemento.tipoMeta==='Facturación'){
    this.props.allMetaRtes1.refetch()
  }
  if(elemento.tipoMeta==='Utilidad'){
    this.props.allMetaRtes2.refetch()
  }
  document.body.style.cursor = 'default'
}

render(){
  const {argsDocum, permiteUpdate, confirmaAct, open, list, list1} = this.state;

// const GerMeta2 = ({autorizacUA, styles, metaTipo, handleClick, list, handleClickidLista}) => {
  const a250501 = this.props.autorizacUA.findIndex( autorizac => autorizac === "250501" );
  let fechaHoy = moment(new Date()).format('YYYY-MM-DD')
  let fechaIni = new Date()
  fechaIni = (fechaHoy.substr(0, 4) + '-01-01')
  fechaIni=moment(fechaIni)
  const numDM = getNumDiasMes(fechaHoy.substr(5, 2), fechaHoy.substr(0, 4))
  const numDF = parseInt(fechaHoy.substr(8, 2), 10)
  const avanceMes = parseInt((numDF*100)/numDM, 10)
  const avanceAgno = 0

  let lista = []
  if (this.props.metaTipo==='Comercial') {
    if(this.props.allMetaRtes.allMetaRtes){lista = this.props.allMetaRtes.allMetaRtes}
  }
  if (this.props.metaTipo==='Facturación') {
    if(this.props.allMetaRtes1.allMetaRtes){lista = this.props.allMetaRtes1.allMetaRtes}
  }
  if (this.props.metaTipo==='Utilidad') {
    if(this.props.allMetaRtes2.allMetaRtes){lista = this.props.allMetaRtes2.allMetaRtes}
  }

  return (
    <div>
      <List selection>
      {this.props.metaTipo==='Comercial' &&  
        <TitDer list={list} textBoton1="Metas comerciales" btnNuevo={a250501!==-1?"SI":"NO"} styles={this.props.styles} handleClick={this.props.handleClick} />
      }
      {this.props.metaTipo==='Facturación' &&  
        <TitDer list={list} textBoton1="Metas de facturación" btnNuevo={a250501!==-1?"SI":"NO"} styles={this.props.styles} handleClick={this.props.handleClick} />
      }
      {this.props.metaTipo==='Utilidad' &&  
        <TitDer list={list} textBoton1="Metas " btnNuevo={a250501!==-1?"SI":"NO"} styles={this.props.styles} handleClick={this.props.handleClick} />
      }
      <div>
        <div style={{height: '60em', overflow: 'auto'}}>
          <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                {/* <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Tipo de meta</th> */}
                <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Año</th>
                <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Mes</th>
                <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>% Avance mes</th>
                <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>% Avance año</th>
                <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Estado</th>
                {this.props.metaTipo!=='Utilidad' &&
                  <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Responsable</th>
                }
                {/* {this.props.metaTipo==='Comercial' &&
                  <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>Grupo</th>
                }               */}
                <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Meta mes</th>
                {this.props.metaTipo!=='Utilidad' &&
                  <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Meta año</th>
                }              
                {this.props.metaTipo!=='Utilidad' &&
                  <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Meta acumulada año</th>
                }
                {this.props.metaTipo!=='Utilidad' &&
                  <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>Real mes a hoy</th>
                }
                {this.props.metaTipo!=='Utilidad' &&
                  <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>Ideal mes a hoy</th>
                }
                <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>%Cump. mes</th>
                <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}></th>
                {this.props.metaTipo!=='Utilidad' &&
                  <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>Real año a hoy</th>
                }
                {this.props.metaTipo!=='Utilidad' &&
                  <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '9%'}}>Ideal año a hoy</th>
                }
                <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>%Cump. año</th>
                <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}></th>
                {this.props.metaTipo==='Comercial' &&
                  <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Rango</th>
                }
                {this.props.metaTipo==='Comercial' &&
                  <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Comisión generada (Ventas)</th>
                }
                {this.props.metaTipo==='Comercial' &&
                  <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Recaudo</th>
                }
                {this.props.metaTipo==='Comercial' &&
                  <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Comisión a pagar (Recaudo)</th>
                }
                <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Act.</th>
                <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Cerrar</th>
                {this.props.metaTipo==='Comercial' &&
                  <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>Liq.</th>
                }
                {this.props.metaTipo==='Comercial' &&
                  <th className='center aligned' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '5%'}}>PDF</th>
                }
                </tr>
            </thead>
            <Lista list={lista} metaTipo={this.props.metaTipo} avanceMes={avanceMes} handleClickidLista={this.props.handleClickidLista} handleClickActCerrar={this.handleClickActCerrar}/>
          </table>
          <p></p>
        </div>
      </div>
      </List>
    </div>
  )
  }
};  


export default compose(
  graphql(queries.mutation.editMeta, {name:'editMeta'}),
  graphql(queries.query.allMetaRtes, {name:'allMetaRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoMeta: 'Comercial'}}, {$sort: {agno: -1, mesNum: -1, estado: 1, nombreUsuario: 1}}, {$limit : 100}]`}}}}),
  graphql(queries.query.allMetaRtes, {name:'allMetaRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoMeta: 'Facturación'}}, {$sort: {agno: -1, mesNum: -1, estado: 1}}, {$limit : 100}]`}}}}),
  graphql(queries.query.allMetaRtes, {name:'allMetaRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoMeta: 'Utilidad'}}, {$sort: {agno: -1, mesNum: -1, estado: 1}}, {$limit : 100}]`}}}}),
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  graphql(queries.mutation.fecha, {name:'fecha'}),
  graphql(queries.query.getParametro, {name:'getParametro', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allProducto, {name:'allProducto'}),
  graphql(queries.mutation.editCotizacion, {name:'editCotizacion'}),

)(GerMeta2)
